export default "__VITE_ASSET__DdkarlkR__"